import { render, staticRenderFns } from "./ListaTurmas.vue?vue&type=template&id=59969e0d"
import script from "./ListaTurmas.vue?vue&type=script&lang=js"
export * from "./ListaTurmas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports